import { z } from 'zod';

import {
  BaseFlowBlockSchema,
  BlockType,
  ProducedType,
  returnTypeSchema,
} from '../base/baseSchema.js';

export enum Mode {
  DocumentTemplate = 'DocumentTemplate',
  Markdown = 'Markdown',
  Base64ToFile = 'Base64ToFile',
  Html = 'Html',
}

export const GenerateFileBlockConfigSchema = z.discriminatedUnion('mode', [
  z.object({
    mode: z.literal(Mode.DocumentTemplate),
    documentTemplateId: z.uuid(),
    valuesByDocumentTemplateKey: z.record(z.string(), z.string().optional()),
  }),
  z.object({
    mode: z.literal(Mode.Markdown),
    markdown: z.string(),
  }),
  z.object({
    mode: z.literal(Mode.Base64ToFile),
    base64Payload: z.string(),
  }),
  z.object({
    mode: z.literal(Mode.Html),
    html: z.string(),
  }),
]);

export type GenerateFileBlockConfig = z.infer<typeof GenerateFileBlockConfigSchema>;

export const GenerateFileBlockSchema = BaseFlowBlockSchema.extend({
  type: z.literal(BlockType.GenerateFile),
  config: GenerateFileBlockConfigSchema,
  returnType: returnTypeSchema(ProducedType.FileReference),
});

export type GenerateFileBlock = z.infer<typeof GenerateFileBlockSchema>;
